<template>
	<!-- <el-cascader
		ref="cascader"
		class="cascader-bid"
		v-model="model"
		:placeholder="placeholder"
		:options="options"
		:props="props"
		clearable
		filterable
		@change="changeHandler"
	></el-cascader> -->

	<el-select 
	multiple
	ref="cascader"
	class="cascader-bid"
	v-model="model"
	:placeholder="placeholder"
    :disabled="disabled"
	clearable
	filterable
	@change="changeHandler"
	>
		<el-option
		v-for="item in options"
		:key="item.tbdwcode"
		:label="`${item.tbdwname}`"
		:value="item.tbdwcode"
		style="min-width: 415px; "
		>
		</el-option>
	</el-select>
</template>

<script>
import MODEL from '@/mixins/model'
import TWO_WAY from '@/mixins/2way'

export default {
	props: {
		placeholder: {
			type: String,
			default: ''
		},
		zbprocode: {
			type: String,
			default: ''
		},
		isXt: {
            type: String,
			default: ''
        },
        zgys: {
            type: Boolean,
			default: false
        },
        bdcodes: {
            type: String,
			default: ','
        },
        disabled: {
            type: Boolean,
            default: false
        },
	},
	mixins: [MODEL, TWO_WAY],
	data() {
		return {
			options: [],
			map: {}
		};
	},
	computed: {
		model: {
			get() {
				if(getType(this.value) === 'string') {
					if(!this.value) {
						return [];
					};
					return this.value.split(',').reduce((arr, item) => {
						item && arr.push(item);
						return arr;
					}, []);
				};
				return this.value;
			},
			set(val) {
				if(getType(val) === 'array') {
					var value = '';
					if(val.length) {
						value = val.join(',') + ',';
					};
					this.$emit('input', value);
				} else {
					this.$emit('input', val);
				};
			}
		}
	},
	watch: {
		bdcodes() {
			this.queryData();
		}
	},
	methods: {
		queryData(node, resolve) {
			if(!this.bdcodes) return;
			if(this.zgys&&(this.isXt==0||this.isXt==undefined)) {
				this.$get(`${this.getGetters('bidUrl')}/FangAn/TbYqs/get_dwlist.json`, {
					bdcodes: this.bdcodes,
                    tbdwcodes:null

				}, data => {
					var arr;
					try{
						arr = JSON.parse(data.rows);
					} catch(e) {
						arr = data.rows;
					};
					this.options = arr;
					this.map = arr.reduce((obj, item) => {				
						obj[item.tbdwcode] = item;			
						return obj;						
					}, {});
				});
			}
		},
		changeHandler(e) {
			var selNode = e.reduce((arr, item) => {
				arr.push(this.map[item]);
				return arr;
			}, []);
				var selNodeMap = selNode.map(item => item.tbdwname);
				var tbdwname = '';
				if(selNodeMap.length) {
					tbdwname = (selNode.map(item => item.tbdwname).join(',') );                    
				};
				this.twoWayHandler({
					tbdwname
				});
				this.$emit('select', selNode);
		}
	},
	created() {
		this.queryData();
	}
}
</script>

<style>
	.cascader-bid{width:100%;}
	/deep/ .el-select-dropdown{
    max-height: 274px;
    min-width: 415px!important;
}
</style>


              